import { ElementType } from 'react';

import { ButtonProps } from '@mui/material';

import clsx from 'clsx';

import { IconButton } from './styles';

interface ToolbarButtonProps<C extends ElementType<any>> {
  component?: C;
  isActive?: boolean;
}

export type Props<C extends ElementType<any> = 'button'> = ButtonProps<C, ToolbarButtonProps<C>>;

const ToolbarButton = <C extends ElementType<any> = 'button'>({
  className,
  children,
  isActive,
  ...restProps
}: Props<C>) => {
  return (
    <IconButton variant="text" size="small" iconOnly {...restProps} className={clsx({ active: isActive }, className)}>
      {children}
    </IconButton>
  );
};

export default ToolbarButton;
